import React, {Component} from "react";
import Table from "../../components/Table";
import DeliveryItem from "./DeliveryItem";
import EmptyStatus from "../../components/EmptyStatus";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import PaginatorButton from "../../components/PaginatorButton";
import {fromJS, List} from "immutable";
import {Query} from "react-apollo";
import {LIST_ORDERS_FOR_ACCOUNT} from "../../queries/shipping";

class DeliveryList extends Component {

  render() {
    let params = {filter: {accountId: this.props.accountId}}
    let tableHeader = List([
      "Order #",
      "Shipping Date",
      "", // tags like gift
      "Recipient",
      "Nr Packages",
      "Fulfillment",
      "Tags"
    ])              
    return (
      <Query query={LIST_ORDERS_FOR_ACCOUNT} variables={params}>
        {({ loading, error, data, fetchMore }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let shipments = fromJS(data.shippingOrders);
          if (shipments.size === 0) {
            return <EmptyStatus status="No deliveries" />
          }
          return (
            <div>
              <Table 
                data={shipments.get("entries")} 
                mode="table"
                renderer={DeliveryItem} 
                tableHeader={tableHeader}
                itemKey="orderId"
                />
              <PaginatorButton 
                metadata={shipments.get("metadata")} 
                onNext={this.handleNext.bind(this, fetchMore)}
                />
            </div>                
          )
        }}
      </Query>
    )
  }

  handleNext(fetchMore, afterId) {
    fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          shippingOrders: {
            __typename: prev.shippingOrders.__typename,
            metadata: fetchMoreResult.shippingOrders.metadata,
            entries: [...prev.shippingOrders.entries, ...fetchMoreResult.shippingOrders.entries]
          }
        }
      }
    })
  }    

}

DeliveryList.defaultProps = {
  accountId: ""
}

export default DeliveryList;